import {View} from './view';
import { Translations } from '../config/translations';

export class RecaptchaV2View extends View {

    private widgetId: any;

    render = () => {
        const recaptchaForm = document.createElement('div');
        recaptchaForm.setAttribute('id', 'df-recaptcha-form-block');
        recaptchaForm.classList.add('df-f', 'df-f-recaptcha-2');

        recaptchaForm.innerHTML =
            `<label id='recaptcha-message'></label>
            <div id='df-recaptcha-form'></div>`;

        const recaptchaFormFragment = document.createDocumentFragment();
        recaptchaFormFragment.appendChild(recaptchaForm);

        const container = this.getDFContainer();
        container.appendChild(recaptchaFormFragment);
    }

    showRecaptchaMessage = (message: string) => {
        const element = this.getHtmlElement('#recaptcha-message');
        element.innerText = message;
        this.show(element);
    }

    renderCheckbox = (grecaptcha: any, recaptchaVerifyCallback: any) => {
        this.widgetId = grecaptcha.render('df-recaptcha-form', {
            'sitekey' : `${process.env.RECAPTCHA_V2_SITE_KEY}`,
            'callback': recaptchaVerifyCallback
        });
    }

    resetCheckbox = (grecaptcha: any) => {
        grecaptcha.reset(this.widgetId);
    }

}
